import { isEmpty } from 'radash';
import { useEffect, useState } from 'react';

import { ItemDetails } from '@/components/ItemDetails/ItemDetails';
import { useItem } from '@/dialogs/item-editor/ItemEditor.queries';
import { getInjector, getRootScope } from '@/services/angularjs-bridge';
import { PersistedItem } from '@/types/DataModel';

import ItemDetailsToolbar from './ItemDetailsToolbar';
import ItemsPaginationFooter from './ItemsPaginationFooter';

const ItemDetailsPage = () => {
    //TOFIX remove angularJSInjector when migrate the catalog page
    const $angularJSInjector = getInjector();
    const $rootScope = getRootScope($angularJSInjector);
    const storedOnlineCatalogState = sessionStorage.getItem('onlineCatalogState');
    const onlineCatalogState = $rootScope.onlineCatalogState || (storedOnlineCatalogState && JSON.parse(storedOnlineCatalogState));

    const [currentItemIndex, setCurrentItemIndex] = useState<number | null>(
        null,
    );
    const [primaryKey, setPrimaryKey] = useState<string>('');

    const { data: item, isPending: isLoadingItem } = useItem({
        variables: {
            primaryKey__: primaryKey,
        },
        enabled: !isEmpty(primaryKey),
    });

    //TOFIX: we need to use useParam when we setup the routing
    useEffect(() => {
        const path = window.location.pathname;
        const segments = path.split('/');
        const _primaryKey = segments[3];

        setPrimaryKey(_primaryKey);
    }, []);

    useEffect(() => {
        const getCurrentItemIndex = () => {
            if (onlineCatalogState && !isEmpty(onlineCatalogState.items) && Array.isArray(onlineCatalogState?.items)) {
                const index = onlineCatalogState?.items.reduce(
                    (
                        acc: number | null,
                        currentValue: PersistedItem,
                        index: number,
                    ) => {
                        if (
                            currentValue?.primaryKey__ === item?.primaryKey__ &&
                            acc === null
                        ) {
                            return index;
                        }
                        return acc;
                    },
                    null,
                );
                setCurrentItemIndex(index);
            } else {
                setCurrentItemIndex(null);
            }
        };
        if (item) {
            getCurrentItemIndex();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingItem, item?.primaryKey__, onlineCatalogState]);

    const handleNavigateToItem = (targetItem: PersistedItem, index: number) => {
        setPrimaryKey(targetItem.primaryKey__);
        setCurrentItemIndex(index);
    };

    return (
        (primaryKey && item )&& (
            <>
                <ItemDetailsToolbar
                    primaryKey={primaryKey}
                    startMappingEditor={undefined}
                    startTemplateMappingSelector={undefined}
                />
                <div className="tw-h-[65vh] tw-flex tw-flex-col">
                    <ItemDetails
                        itemData={item}
                        primaryKey={primaryKey}
                        isInEditorMode={false}
                    />
                </div>
                {currentItemIndex !== null && (
                    <ItemsPaginationFooter
                        style={'tw-w-full tw-bg-white tw-shadow-[1px_2px_1px_#f5f3f3] tw-rounded-bl-sm tw-rounded-br-sm tw-flex tw-justify-center tw-py-2 tw-z-20'}
                        isItemEditorDialog={false}
                        currentItemIndex={currentItemIndex}
                        onlineCatalogState={onlineCatalogState}
                        onNavigateToItem={handleNavigateToItem}
                    />
                )}
            </>
        )
    );
};

export { ItemDetailsPage };
